import React, { useState } from "react";
import { X } from "lucide-react";
import { REALISATIONS } from "../lib/site";
import SectionHeading from "./SectionHeading";

/**
 * Section "Nos réalisations" — galerie responsive avec lightbox simple.
 */
export default function Realisations() {
  const [active, setActive] = useState(null);

  return (
    <section
      data-testid="realisations-section"
      className="section-padding bg-white"
      id="realisations"
    >
      <div className="container-x">
        <SectionHeading
          eyebrow="Nos réalisations"
          title="Travaux récents soignés et conformes."
          description="Tableaux électriques Legrand, Schneider, Hager — installations complètes, mises aux normes et rénovations réalisées chez nos clients."
        />

        <div className="mt-14 grid grid-cols-2 lg:grid-cols-3 gap-3 lg:gap-5">
          {REALISATIONS.map((item, i) => (
            <button
              key={i}
              type="button"
              data-testid={`realisation-${i}`}
              onClick={() => setActive(item)}
              className={`group relative overflow-hidden bg-slate-100 cursor-zoom-in ${
                i === 0 ? "lg:col-span-2 lg:row-span-2 aspect-square lg:aspect-auto" : "aspect-square"
              }`}
            >
              <img
                src={item.src}
                alt={item.alt}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/85 via-slate-900/20 to-transparent opacity-100 lg:opacity-0 lg:group-hover:opacity-100 transition-opacity" />
              <div className="absolute left-0 right-0 bottom-0 p-4 lg:p-5 text-left text-white opacity-100 lg:opacity-0 lg:group-hover:opacity-100 transition-opacity">
                <p className="font-heading font-semibold text-base lg:text-lg leading-tight">{item.caption}</p>
                <div className="mt-2 flex flex-wrap gap-1.5">
                  {item.tags.map((t) => (
                    <span key={t} className="text-[10px] uppercase tracking-wider bg-[#EAB308] text-slate-900 px-2 py-0.5 font-semibold">
                      {t}
                    </span>
                  ))}
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {active && (
        <div
          data-testid="realisation-lightbox"
          className="fixed inset-0 z-[100] bg-black/90 flex items-center justify-center p-4 animate-fade-up"
          onClick={() => setActive(null)}
        >
          <button
            data-testid="lightbox-close"
            onClick={() => setActive(null)}
            className="absolute top-5 right-5 text-white p-2 hover:bg-white/10 rounded-sm"
            aria-label="Fermer"
          >
            <X className="w-7 h-7" />
          </button>
          <div className="max-w-5xl w-full" onClick={(e) => e.stopPropagation()}>
            <img
              src={active.src}
              alt={active.alt}
              className="w-full max-h-[80vh] object-contain"
            />
            <p className="mt-4 text-center text-white font-medium">{active.caption}</p>
          </div>
        </div>
      )}
    </section>
  );
}
